export const isInWix = () => {
  return typeof window !== 'undefined' && window.top !== window.self;
};



// WEBPACK FOOTER //
// ./app/services/is-in-wix.js